/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { SortOrderValue } from "@src/shared/constants/sort-order.constants";

interface GetBusinessPoliciesParams {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: string;
  orderBy?: string;
  orderDirection?: SortOrderValue | Lowercase<SortOrderValue>;
  [key: string]: any;
}



export class BusinessPolicyService {
  async getBusinessPolicies(query: GetBusinessPoliciesParams) {
    return apiService.get("/business-policies", { params: sanitizeQueryParams(query) });
  }

  async getBusinessPolicy(id: string | number) {
    return apiService.get(`/business-policies/${id}`);
  }

  async createBusinessPolicy(data: any) {
    return apiService.post("/business-policies", data);
  }

  async updateBusinessPolicy(id: string | number, data: any) {
    return apiService.put(`/business-policies/${id}`, data);
  }

  async deleteBusinessPolicy(id: string | number) {
    return apiService.delete(`/business-policies/${id}`);
  }

  async getBusinessesDropdown() {
    return apiService.get("/deeplinks/businesses-dropdown"); // Using deeplink's endpoint for dropdown since it's the same
  }
}

export const businessPolicyService = new BusinessPolicyService();
